import React from "react";
import "./Steps.css";

export default function StepsSection() {   // ✅ default export
  return (
    <section className="steps-section">
      <div className="steps-container">
        <div className="step">
          <span className="step-number">1.</span>
          <p>If you're a healthcare provider, please log in with your workplace credentials.</p>
        </div>
        <div className="step">
          <span className="step-number">2.</span>
          <p>Check your client's measurement status.</p>
        </div>
        <div className="step">
          <span className="step-number">3.</span>
          <p>Analyze and utilize the gathered measurements for their desired purpose.</p>
        </div>
      </div>
    </section>
  );
}
